"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signinRoutes = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_1 = require("react-router");
const pageLoader_1 = __importDefault(require("../loaders/pageLoader"));
const reactivateLoader_1 = require("../loaders/signin/reactivateLoader");
const registerActivateLoader_1 = require("../loaders/signin/registerActivateLoader");
const AmexRegistrationForm = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../components/pages/userAccount/registerForm'))));
const HsbcAccountPage = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../components/pages/userAccount/hsbc/accountPage'))));
const AmexActivateForm = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../components/pages/userAccount/activateForm'))));
const ErrorPage = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../components/pages/errorPage'))));
const LoginForm = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../components/pages/userAccount/loginform'))));
const ForgotPassword = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../components/pages/userAccount/forgotPassword'))));
const ResetPassword = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../components/pages/userAccount/resetPassword'))));
const MessagePage = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../components/pages/userAccount/common/messagePage'))));
const signinPath = '/signin';
const IS_AMEX_PROVIDER = globalThis.IS_PLAYWRIGHT_RUNNING
    ? globalThis.PLAYWRIGHT_CARD_PROVIDER === 'AMEX'
    : globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP;
// global flag to allow register page access via console only for sandbox
const ALLOW_REGISTER_PAGE_ACCESS = globalThis.config.IS_SANDBOX
    ? localStorage.getItem('ALLOW_REGISTER_PAGE_ACCESS') === 'true' || globalThis.ALLOW_REGISTER_PAGE_ACCESS || false
    : false;
const isSandOrProdOrDemoEnv = globalThis.config.IS_PRODUCTION || globalThis.config.IS_SANDBOX || globalThis.config.IS_DEMO;
exports.signinRoutes = {
    path: signinPath,
    element: (0, jsx_runtime_1.jsx)(react_router_1.Outlet, {}),
    children: [
        {
            index: true,
            element: ((0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: (0, jsx_runtime_1.jsx)(LoginForm, {}) })),
        },
        {
            path: 'login',
            element: ((0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: (0, jsx_runtime_1.jsx)(LoginForm, {}) })),
        },
        {
            // Redirect /signin/get-started to /signin/login
            // TODO : remove it after back-end removes this route
            path: 'get-started',
            element: (0, jsx_runtime_1.jsx)(react_router_1.Navigate, { to: `${signinPath}/login`, replace: true }),
        },
        {
            path: 'password/forgot',
            element: ((0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: (0, jsx_runtime_1.jsx)(ForgotPassword, {}) })),
        },
        {
            path: 'reactivate/:userId/:activationToken',
            element: ((0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: (0, jsx_runtime_1.jsx)(ResetPassword, {}) })),
            loader: reactivateLoader_1.reactivateLoader,
        },
        {
            path: 'register',
            element: ((0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: IS_AMEX_PROVIDER ? ((0, jsx_runtime_1.jsx)(AmexRegistrationForm, {})) : isSandOrProdOrDemoEnv && !ALLOW_REGISTER_PAGE_ACCESS ? ((0, jsx_runtime_1.jsx)(ErrorPage, {})) : ((0, jsx_runtime_1.jsx)(HsbcAccountPage, {})) })),
        },
        {
            path: 'message',
            element: ((0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: (0, jsx_runtime_1.jsx)(MessagePage, {}) })),
        },
        {
            path: 'activate/:userId/:activationToken',
            element: ((0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: IS_AMEX_PROVIDER ? (0, jsx_runtime_1.jsx)(AmexActivateForm, {}) : (0, jsx_runtime_1.jsx)(HsbcAccountPage, {}) })),
            loader: ctx => (0, registerActivateLoader_1.registerActivateLoader)(ctx),
        },
        {
            path: 'register/activate/:userId/:activationToken',
            element: ((0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: IS_AMEX_PROVIDER ? (0, jsx_runtime_1.jsx)(AmexActivateForm, {}) : (0, jsx_runtime_1.jsx)(HsbcAccountPage, {}) })),
            loader: ctx => (0, registerActivateLoader_1.registerActivateLoader)(ctx),
        },
    ],
};
